var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 486.5 327.5",
    style: {
      enableBackground: "new 0 0 486.5 327.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.51;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{opacity:0.3;}\n\t.st3{fill:#E6E6E6;stroke:#B3B3B3;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st4{fill:#999999;}\n\t.st5{fill:#CCCCCC;}\n\t.st6{fill:#CCCCCC;stroke:#B3B3B3;stroke-miterlimit:10;}\n\t.st7{fill:#E6E6E6;}\n\t.st8{fill:#E5E4E4;}\n\t.st9{fill:#B3B3B3;}\n\t.st10{fill:#E6E6E6;stroke:#999999;stroke-miterlimit:10;}\n\t.st11{fill:#808080;}\n\t.st12{fill:#666666;}\n\t.st13{fill:#F2F2F2;}\n\t.st14{fill:#4D4D4D;}\n\t.st15{fill:none;}\n\t.st16{fill:#FFFFFF;stroke:#B3B3B3;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st17{fill:#FFFFFF;stroke:#999999;stroke-miterlimit:10;}\n\t.st18{fill:none;stroke:#999999;stroke-miterlimit:10;}\n\t.st19{fill:#B9B9B9;}\n\t.st20{fill:none;stroke:#B3B3B3;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#E5E4E4;stroke-width:1.296;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.7,53.8c-21.8,15-39.5,34.7-51.4,56.8c-21.5,39.8-34,100.2,5.5,135.1c45.2,40,110.9,14.4,164.8,29.1 c34.3,9.4,60.9,33.7,94.6,44.9c49.4,16.4,110.3-1.1,139.1-39.7c25.8-34.7,25-81.3,5.2-119c-19.8-37.7-56.4-67.1-97.2-88.3 c-51.7-26.9-111.9-52.2-173.6-48.8C128.3,25.6,98.5,36.7,73.7,53.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.4,274.6c37.7,13.4,84.1,17.2,112.2-8.8c28.2-25.9,29.9-63.9,10.2-93.8c-18.6-28.3-51.4-47.8-71-75.6 C376.6,80.6,371.8,62,360.9,46C339.5,14.6,293.3-2.9,254.3,2.6c-37,5.2-65.4,33.6-95.4,57.2c-15.8,12.4-39,20.2-58.5,29.2 c-21.2,9.8-40.9,20.2-55.2,37.5c-27.6,33.4-22.3,59.8-1.9,85.1c20.4,25.3,73,33.7,114.1,25.9C223.5,225,275.1,252.9,336.4,274.6z "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.2,283.6c0,0,22.1-51.7,9.7-83l-14.5,10.6l10.4-24c0,0-30.1-29.4-51.5,4l17.5,12.2l-21.4-0.4l2.7,18.9 l25.6,11.7l-19.2,0.1C21.4,233.6,37.1,268.5,62.2,283.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.7,
    y: 205.1,
    transform: "matrix(0.9817 -0.1903 0.1903 0.9817 -47.3385 15.3347)",
    className: "st4",
    width: 0.9,
    height: 98
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.1,291.9c0,0,27.4-14.8,32.7-32.7l-9.9-0.4l12.7-6.8c0,0-3-23.1-23.7-16l3.4,11.3l-9.1-7.5l-5.3,9.1 l7.1,13.9l-8.4-6.6C74.5,256.2,69.4,276.7,75.1,291.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.5,
    y: 276.8,
    transform: "matrix(0.4601 -0.8879 0.8879 0.4601 -201.3651 222.8968)",
    className: "st4",
    width: 54.3,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M97.7,291.8l-11.4,11.4c-2.4,2.4-5.7,3.8-9.1,3.8H59.8c-3.4,0-6.7-1.4-9.1-3.8l-11.1-11.1 c-1.4-1.4-0.4-3.7,1.5-3.7l55-0.2C98,288.1,99,290.5,97.7,291.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.2,
    y: 94.2,
    className: "st6",
    width: 124,
    height: 88.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3_2_",
    className: "st7",
    d: "M261.5,118.7h38.8c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-38.8 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C259.5,119.9,260.4,118.7,261.5,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3-Copy-2_2_",
    className: "st7",
    d: "M309.3,118.7h10.2c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-10.2 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C307.2,119.9,308.1,118.7,309.3,118.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3_3_",
    className: "st7",
    d: "M261.5,130.8h38.8c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-38.8 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C259.5,132,260.4,130.8,261.5,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3-Copy-2_3_",
    className: "st7",
    d: "M309.3,130.8h10.2c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-10.2 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C307.2,132,308.1,130.8,309.3,130.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3_4_",
    className: "st7",
    d: "M261.5,143h38.8c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-38.8 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C259.5,144.2,260.4,143,261.5,143z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-3-Copy-2_4_",
    className: "st7",
    d: "M309.3,143h10.2c1.1,0,2.1,1.2,2.1,2.6v3.3c0,1.5-0.9,2.6-2.1,2.6h-10.2 c-1.1,0-2.1-1.2-2.1-2.6v-3.3C307.2,144.2,308.1,143,309.3,143z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M354.8,148.6h-24.5c-1.5,0-2.8-1.2-2.8-2.8v-24.5c0-1.5,1.2-2.8,2.8-2.8h24.5c1.5,0,2.8,1.2,2.8,2.8v24.5 C357.5,147.4,356.3,148.6,354.8,148.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.2,
    y: 94.6,
    className: "st4",
    width: 124,
    height: 17.1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-10_2_",
    className: "st8",
    d: "M241.8,101.3h96.8c0.7,0,1.3,0.6,1.3,1.3v1.9c0,0.7-0.6,1.3-1.3,1.3h-96.8 c-0.7,0-1.3-0.6-1.3-1.3v-1.9C240.5,101.8,241.1,101.3,241.8,101.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.5,139.9c-4.1-1.2-6.6,6-7.9,11.8l-7-9.6l-23.2,15.5l7.2,24.2l31.2-19 C131.8,162.9,139.4,142.1,131.5,139.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "310.7,186.7 310.7,236.7 294.6,254.5 259,293.8 185.7,293.8 188.7,225.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "270.7,160.7 265.8,180.4 216,177.3 221.9,162 226.1,126.3 260.6,103.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M246.2,126.2c-3.9,10.5-12.5,19.1-22.8,23.5l2.6-22.3l10.3-6.7C239.6,122.5,242.8,124.3,246.2,126.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.3,127.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M265.1,86c0,0.1,0,0.1,0,0.1l-0.8,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M249.3,127.8c0,0-20.2,20.8-41.1,2.5c-11.6-10.2-14.9-37.2-9.2-58.3c0.2-0.7,0.4-1.3,0.6-2l0.1-0.3 c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.1,0.1-0.2c0.2-0.8,0.5-1.5,0.8-2.3c0.2-0.5,0.4-1.1,0.6-1.6c0.3-0.7,0.5-1.3,0.8-2 c3.1-7,7.3-12.7,12.9-16.1c1.3-0.8,2.6-1.4,4-2c0.6-0.2,1.3-0.5,2-0.6c0.5-0.2,1.1-0.3,1.6-0.4c1.4-0.3,2.9-0.4,4.5-0.4 c0.1,0,0.3,0,0.4,0c13.4,0.1,21.9,5.5,27.5,12.4c7,8.7,9.1,19.8,9.7,25.7c0,0.2,0,0.4,0.1,0.6l0,0.3l0,0.6c0,0.5,0.1,1,0.1,1.4 c0,0.5,0,0.9,0.1,1.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M218.2,108.1c-1.2,0-2.4-0.5-3.3-1.4c-0.8-0.9-1.3-2.2-1.2-3.4l1.3-15.9l2.1,0.2l-1.3,15.9 c-0.1,0.7,0.2,1.3,0.6,1.8c0.5,0.5,1.1,0.8,1.8,0.8c0,0,0,0,0,0L218.2,108.1C218.2,108.1,218.2,108.1,218.2,108.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M227.9,89c0,1.2,0.7,2.2,1.6,2.2c0.9,0,1.6-1,1.6-2.2c0-1.2-0.7-2.2-1.6-2.2C228.5,86.8,227.9,87.8,227.9,89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.2,89c0,1.2,0.7,2.2,1.6,2.2c0.9,0,1.6-1,1.6-2.2c0-1.2-0.7-2.2-1.6-2.2C204.9,86.8,204.2,87.8,204.2,89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M233.2,78.8c0.7,0.2,1.3,0.4,1.9,0.7s0.9,0.8,0.8,1.3c-0.1,0.8-1.4,1.1-2.5,1.2c-2.4,0.2-4.9-0.1-7.3-0.8 c-0.8-0.2-1.7-0.6-2-1.2c-0.6-1.4,1.9-1.8,2.9-1.8C229.1,78,231.3,78.3,233.2,78.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M208.3,78.1c0.6,0.1,1.2,0.1,1.7,0.4c0.5,0.2,0.9,0.6,0.9,1.1c0,0.7-1.1,1.2-2,1.4c-2,0.5-4.3,0.7-6.4,0.4 c-0.7-0.1-1.6-0.3-1.8-0.8c-0.7-1.1,1.5-1.9,2.3-2.1C204.7,78,206.6,78,208.3,78.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M351.8,261.5l-5.8,46.6c0,0-68.1-17.4-95,0c-3.1,2-71.5-16.3-75-15.4c-2.4,0.6-4.9,1-7.5,1 c-26.8,0-54.5-53.3-68.4-84.4c-5.7-12.7-9.1-21.7-9.1-21.7l45.5-27.7l9.9,15.5l18.1,28.3c0,0,14.5-26.8,23.2-34.5 c8.7-7.7,33.5-7.1,33.5-7.1c7.4,27.7,49.4-1.3,49.4-1.3s31-2.3,41,1.6C323.5,167,363,232.5,351.8,261.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "294.6,254.5 259,293.8 193.5,289.6 233.5,239.6 280.5,221.4 287.3,201  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M240.9,246.7l13,35.9c0,0-41,8.2-44.7,4.4c-2.2-2.3-0.4-4-0.4-4s-4.1,1.3-5.8-0.5c-1.8-1.8-0.4-4-0.4-4 s-3.7,0.6-4-2.8c-0.3-3.7,9.8-10.7,20.2-16.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M220.7,258.8c-7.3,2.1-12,0.4-12.6-3.5c-0.4-3.2,10.8-5.8,20.6-6.5c6.6-0.5,14.1-2.1,14.1-2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M222.7,260.8c-7.3,2.1-12,0.4-12.6-3.5c-0.4-3.2,10.8-5.8,20.6-6.5c6.6-0.5,14.1-2.1,14.1-2.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M244.9,248.7l13,35.9c0,0-41,8.2-44.7,4.4c-2.2-2.3-0.4-4-0.4-4s-4.1,1.3-5.8-0.5c-1.8-1.8-0.4-4-0.4-4 s-3.7,0.6-4-2.8c-0.3-3.7,9.8-10.7,20.2-16.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M205.2,282.2l-1.4-1.5c0.2-0.2,8.1-6.5,17.2-10.5l0.8,1.9C213,275.9,205.2,282.2,205.2,282.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M211.3,286.8l-1.1-1.7c0.3-0.2,8.5-5.1,14.8-7.8l0.8,1.9C219.6,281.8,211.4,286.8,211.3,286.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M229.1,14.6c5.8-1.3,12.3,1.5,15.3,6.6c3.1,5.1,2.5,12.1-1.3,16.6c-3.8,4.5-10.6,6.3-16.2,4.2 C214.1,36.9,215.6,17.6,229.1,14.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M351.8,261.5c-7.7,20.7-45.6,28.1-71.8,30.8c-14.6,1.5-25.6,1.5-25.6,1.5l-14.2-51l19-6.9l28.1-10.2v-24.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M351.8,261.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M287.3,200.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M188.6,225.4l-2.7,62.9c-3.1,2-6.4,3.6-9.9,4.5L188.6,225.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.834 -0.5518 0.5518 0.834 -34.5704 97.3382)",
    className: "st4",
    cx: 144.5,
    cy: 106.1,
    rx: 34.8,
    ry: 34.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.9,173.2L91.9,173.2c-3.6-2.8-4.1-8.1-1.1-11.5l41.9-48.8l8.1,6.4l-37.4,52.3 C100.7,175.2,95.5,176,91.9,173.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M165.1,122.2c-1.5,1.9-3.2,3.6-5.1,4.9c-3.7,2.7-8,4.4-12.5,4.9c-6.6,0.8-13.5-1-19.1-5.4 c-2.6-2.1-4.7-4.5-6.3-7.2c-3.4-5.6-4.5-12.4-3.1-18.7c0.8-3.8,2.5-7.5,5-10.8c5.7-7.2,14.3-10.7,22.8-9.9c2.5,0.2,5,0.8,7.4,1.8 c2.1,0.8,4.1,1.9,5.9,3.3c0.2,0.1,0.3,0.3,0.5,0.4c1,0.8,2,1.7,2.9,2.6C172.2,97.4,173.1,111.9,165.1,122.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M119.9,160.7c0,0,1.6,1.9-0.8,3.9c-2.3,2-23.1-2-25.6-5.6c-3.5-5,10.8-23.5,19-23 c6.6,0.4,18.8,14.9,18.1,18.5c-0.6,3.3-4.1,2.3-4.1,2.3s1.1,2.3-0.8,3.9C123.7,162.4,119.9,160.7,119.9,160.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M128.7,159.5c-0.1-0.1-8.2-7.8-16.4-12.4l1-1.8c8.5,4.8,16.7,12.6,16.9,12.8L128.7,159.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M122.3,163.5c-0.1,0-8.8-6.5-14.5-9.7l1-1.8c5.9,3.2,14.6,9.7,14.8,9.8L122.3,163.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M203.4,105.3c-5.8,0-10.5-4.7-10.5-10.6c0-5.8,4.7-10.6,10.5-10.6c5.8,0,10.6,4.7,10.6,10.6 C214,100.6,209.3,105.3,203.4,105.3z M203.4,86.3c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5 C211.9,90.1,208.1,86.3,203.4,86.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M227.3,105.3c-5.8,0-10.6-4.7-10.6-10.6c0-5.8,4.7-10.6,10.6-10.6c5.8,0,10.5,4.7,10.5,10.6 C237.9,100.6,233.1,105.3,227.3,105.3z M227.3,86.3c-4.7,0-8.5,3.8-8.5,8.5c0,4.7,3.8,8.5,8.5,8.5c4.7,0,8.5-3.8,8.5-8.5 C235.8,90.1,232,86.3,227.3,86.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 93.5,
    className: "st14",
    width: 4.8,
    height: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.9,
    y: 86.3,
    transform: "matrix(0.8662 -0.4996 0.4996 0.8662 -10.2644 136.2987)",
    className: "st14",
    width: 29,
    height: 2.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M264.8,81.9c-9.2,0.3-18.5-2.6-25.9-8.1c-7.5-5.5-12.9-13.7-15.3-22.7c-5.7,8.4-14.1,14.9-23.7,18.1 c0-0.1,0-0.1,0.1-0.2c0.2-0.8,0.5-1.5,0.8-2.3c0.2-0.5,0.4-1.1,0.6-1.6c0.3-0.7,0.5-1.3,0.8-2c3.1-7,7.3-12.7,12.9-16.1 c1.3-0.8,2.6-1.4,4-2c0.6-0.2,1.3-0.5,2-0.6c0.5-0.2,1.1-0.3,1.6-0.4c1.4-0.3,2.9-0.4,4.5-0.4c0.1,0,0.3,0,0.4,0 c13.4,0.1,21.9,5.5,27.5,12.4C262.1,64.9,264.2,76,264.8,81.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.5,84.7c1.5-2.4,4.4-3.6,7.2-3.5c2.8,0.2,5.4,1.7,7.3,3.8c4.3,4.7,4.8,12.5,1,17.7 c-3.7,5.2-11.3,7.2-17.1,4.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M265.5,99.8l-2.1-0.1c0.2-3.4-1-6.8-3.4-9.3l0.8-1.8l6.2,0.2l-0.1,2.1l-4-0.1 C264.8,93.4,265.7,96.6,265.5,99.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M219,113.6l-0.1-2.1c1.5-0.1,2.5-0.4,3.3-1c0.8-0.6,1.3-1.5,1.3-2.5l2.1,0.1c-0.1,1.6-0.9,3.1-2.1,4.1 C222.3,113,220.9,113.5,219,113.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M285.3,160.6c-0.8,0-1.5-0.2-2.1-0.4c-4,4.8-8.1,9.2-12.6,13.1c-7.6,6.5-15.4,10.6-23.3,12.2 c-9.2,1.9-18.5,0.1-25.1-4.8c-6-4.4-9.4-11.5-9.4-18.2c-0.4,0.1-0.8,0.1-1.3,0.1c-0.3,0-0.6,0-0.8-0.1c0,7.4,3.8,15,10.2,19.8 c5.2,3.9,12.1,5.9,19.2,5.9c2.5,0,5-0.2,7.5-0.8c8.3-1.7,16.4-6,24.3-12.7c4.9-4.2,9.2-9,13.6-14.3 C285.5,160.6,285.4,160.6,285.3,160.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M351.8,261.5l-7.3,34.1c0,0-82.1-11.4-109,6c-3.1,2-56-9.8-59.5-8.9c-2.4,0.7-4.9,1-7.5,1 c-37.7,0-77.4-106.1-77.4-106.1l45.5-27.7l28.1,43.9c0,0,14.5-26.8,23.2-34.5s33.5-7.1,33.5-7.1c7.4,27.7,49.4-1.3,49.4-1.3 s31-2.3,41,1.6C323.5,167,363,232.5,351.8,261.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M146.6,175.4l-46.4,33.9c-5.7-12.7-9.1-21.7-9.1-21.7l45.5-27.7L146.6,175.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M280,292.3c-14.6,1.5-25.6,1.5-25.6,1.5l-14.2-51l19-6.9L280,292.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104.4,198c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3 C108.8,196,106.8,198,104.4,198z M104.4,191.4c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c1.3,0,2.3-1,2.3-2.3S105.7,191.4,104.4,191.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M262.8,284.8c-2.4,0-4.3-1.9-4.3-4.3c0-2.4,1.9-4.3,4.3-4.3c2.4,0,4.3,1.9,4.3,4.3 C267.1,282.9,265.2,284.8,262.8,284.8z M262.8,278.2c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3s2.3-1,2.3-2.3S264.1,278.2,262.8,278.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M300.2,69.3c-0.5,0-1.1,0-1.6-0.1l0,0c-5.9-0.6-10.8-6.4-10.5-12.3c0.3-5.9,5.8-11.1,11.7-11.1c0,0,0,0,0.1,0 c4.7,0,8.3,2.1,10.3,5.8c2.1,4,1.9,9.2-0.7,12.9C307.4,67.6,304.2,69.3,300.2,69.3z M298.8,67.1c3.9,0.4,7.1-0.9,9-3.8 c2.1-3.1,2.3-7.5,0.6-10.8c-1.6-3-4.6-4.7-8.5-4.7c0,0,0,0-0.1,0c-4.9,0-9.4,4.3-9.6,9.2C290,61.9,294,66.6,298.8,67.1L298.8,67.1 z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 68.8,
    y: 288.3,
    className: "st17",
    width: 407.5,
    height: 35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 85.8,
    y1: 301.4,
    x2: 243.6,
    y2: 301.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 97.3,
    y1: 314.1,
    x2: 255.1,
    y2: 314.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 286.4,
    y1: 295.7,
    x2: 444.2,
    y2: 295.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 297.9,
    y1: 308.4,
    x2: 455.7,
    y2: 308.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M460,211.6c-3.9,2.6-94.3,0-94.3,0l-31.5,76.7h122.7l26.6-76.7H460z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.2,
    y: 278.6,
    className: "st19",
    width: 91.5,
    height: 9.7
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2298 -0.9732 0.9732 0.2298 227.6319 379.5162)",
    className: "st7",
    cx: 353.6,
    cy: 45.9,
    rx: 26.3,
    ry: 26.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M353.6,57.5h-13.2c-2.1,0-3.3-2.2-2.3-4l6.6-11.4l6.6-11.4c1-1.8,3.6-1.8,4.6,0l6.6,11.4l6.6,11.4 c1,1.8-0.3,4-2.3,4H353.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M353.2,48.5l-0.8-13.7c0-0.3,0.2-0.5,0.5-0.5h1.5c0.3,0,0.5,0.2,0.5,0.5l-0.7,13.7c0,0.3-0.2,0.5-0.5,0.5 l0,0C353.4,49,353.2,48.8,353.2,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M354.9,51.2c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3C354.3,50,354.9,50.5,354.9,51.2z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13_2_",
    transform: "translate(199.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line-10_4_",
    className: "st21",
    d: "M153.5,101.3l4.7-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line-10_1_",
    className: "st21",
    d: "M158.2,101.3l-4.7-4.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgError);
export default __webpack_public_path__ + "static/media/img-error.a087946eadb0ac947348641aaf071a4c.svg";
export { ForwardRef as ReactComponent };